import { DialogProps } from '@mui/material/Dialog/Dialog';
import { createDispute } from 'config/requests/orders';
import { queryClient } from 'providers/queryClient';
import { Controller, useForm } from 'react-hook-form';
import { Button } from 'shared/mui/Buttons';
import { Card, CardActionsButtons } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { DatePicker } from 'shared/mui/DatePicker/DatePicker/DatePicker';
import { Dialog } from 'shared/mui/Dialogs';
import { TextField } from 'shared/mui/Fields';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { Order } from 'types/embedded/order';

type Props = {
  order: Order | undefined;
  onClose: () => void;
} & DialogProps;

export const OrdersShowDisputesCreateDialog = ({ order, onClose, open }: Props): JSX.Element => {
  const form = useForm();

  if (!order) {
    return <></>;
  }
  const handleSubmit = () => {
    createDispute({
      ...form.getValues(),
      openedAt: form.getValues('openedAt') / 1000,
      order: order.id,
    }).then(() => {
      queryClient.invalidateQueries({ queryKey: ['order_disputes'] });
      onClose();
      form.reset();
    });
  };

  return (
    <Dialog maxWidth="md" onClose={onClose} open={open}>
      <Card sx={{ width: '640px' }}>
        <form {...form}>
          <CardHeader
            appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
            title="Открыть диспут"
            titleSize="smallBold"
          />
          <CardContent>
            <Stack gap={3}>
              <Typography>По заказу #{order?.originId || ''} будет открыт диспут.</Typography>
              <Controller
                control={form.control}
                name="openedAt"
                render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
                  <DatePicker
                    error={!!error}
                    helperText={error?.message}
                    label="Дата"
                    maxDate={new Date()}
                    onBlur={onBlur}
                    onChange={onChange}
                    required
                    size="small"
                    value={value || null}
                  />
                )}
                rules={{
                  required: 'Значение не должно быть пустым',
                }}
              />
              <Controller
                control={form.control}
                name="openReason"
                render={({ field, fieldState }) => (
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    error={!!fieldState.error}
                    fullWidth
                    helperText={fieldState.error?.message}
                    label="Причина"
                    multiline
                    onChange={(value) => {
                      field.onChange(value);
                    }}
                    required
                    rows={1}
                    size="small"
                    value={field.value}
                    variant="outlined"
                  />
                )}
                rules={{
                  required: 'Значение не должно быть пустым',
                  maxLength: {
                    value: 255,
                    message: 'Значение слишком длинное. Должно быть равно 255 символам или меньше.',
                  },
                }}
              />
            </Stack>
          </CardContent>
          <CardActionsButtons
            rightActionsSlot={[
              <Button key="cancel-button" label="Отменить" onClick={onClose} variant="outlined" />,
              <Button
                key="confirm-button"
                label="Подтвердить"
                onClick={form.handleSubmit(handleSubmit)}
                variant="contained"
              />,
            ]}
          ></CardActionsButtons>
        </form>
      </Card>
    </Dialog>
  );
};
